<template>
  <div>
    <table
      class="mt-3 mb-1 table table-striped table-bordered table-sm"
      style="width:100%;font-size:.9rem;"
    >
      <thead>
        <tr>
          <th
            v-if="isOpen"
            class="align-middle text-center text-success cursor-pointer"
            rowspan="2"
            title="Aggiungi componente"
            @click="apriForm(),aggiornamento()"
          >
            <font-awesome-icon
              icon="plus"
              class="cursor-pointer text-success"
            />
          </th>
          <th class="align-middle text-center">Nome</th>
          <th class="align-middle text-center">Cognome</th>
          <th class="align-middle text-center">Data di nascita</th>
          <th class="align-middle text-center">Codice Fiscale</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(r,idx) in rows"
          :key="idx"
        >
          <td
            v-if="isOpen"
            class="align-middle text-center text-success"
            title="Modifica componente"
            @click="apriForm(idx),aggiornamento()"
          >
            <font-awesome-icon
              icon="pen"
              class="cursor-pointer text-success"
            />
          </td>
          <td class="align-middle text-nowrap">{{ r.nome }}</td>
          <td class="align-middle text-nowrap">{{ r.cognome }}</td>
          <td class="align-middle text-nowrap">{{ r.dataNascita ? moment(r.dataNascita).format('DD/MM/YYYY') : '' }}</td>
          <td class="align-middle text-nowrap">{{ r.codiceFiscale }}</td>
        </tr>
        <tr v-if="!rows || !rows.length">
          <td
            :colspan="!isOpen ? '11' : '12'"
            class="text-center font-italic"
          >Nessun componente dichiarato</td>
        </tr>
      </tbody>
    </table>
    <familiare-modal ref="modal" />
  </div>
</template>

<script>
import numeral from 'numeral'
import moment from 'moment'
import FamiliareModal from '@/components/FamiliareModal'

export default {
  name: 'FamiliariTable',
  components: {
    FamiliareModal
  },
  props: {
    item: { type: Object, required: true }
  },

  computed: {
    numeral () {
      return numeral
    },
    moment () {
      return moment
    },
    isOpen () {
      return this.item.stato === 'B' || this.item.stato === 'P'
    },
    rows () {
      return this.item.nuoviFamiliari
    }
  },

  methods: {
    apriForm (idx) {
      this.$refs.modal.open({ item: this.item, idx })
    },
    aggiornamento () {
      this.$emit('aggiornaFamiglia')
    }
  }
}
</script>
